import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Mail } from 'lucide-react';
import { mockData } from '../mock';

const Hero = () => {
  const { hero } = mockData;
  const handlePrimaryClick = () => {
    window.open('https://id-preview--4a26bd83-a560-47e7-a09c-f8b140f6f9af.lovable.app/project/new', '_blank', 'noopener,noreferrer');
  };
   const handlePartnerClick = () => {
    window.open('https://id-preview--c77b904a-c66a-40cc-b121-78710928666f.lovable.app/', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-100 rounded-full filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-100 rounded-full filter blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in">
            <div className="inline-block">
              <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-semibold">
                {hero.badge}
              </span>
            </div>

            <div className="space-y-4">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
                {hero.title}
              </h1>
              
              <div className="inline-block">
                <p className="text-2xl font-bold text-blue-600">{hero.subtitle}</p>
              </div>
            </div>

            <p className="text-lg text-gray-600 leading-relaxed">
              {hero.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg transition-all duration-200 hover:shadow-xl hover:scale-105 group"
                onClick={handlePrimaryClick}
              >
                {hero.ctaPrimary}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              {/* <Button
                size="lg"
                variant="outline"
                className="px-8 py-6 text-lg border-2 border-gray-300 hover:border-blue-600 hover:text-blue-600 transition-all duration-200"
                onClick={handlePartnerClick}
              >
                {hero.ctaSecondary}
              </Button> */}
            </div>

            {/* Contact Email */}
            <div className="pt-6 flex items-center gap-3 text-gray-600">
              <Mail className="w-5 h-5 text-blue-600" />
              <a href={`mailto:${hero.email}`} className="text-blue-600 hover:underline font-medium">
                {hero.email}
              </a>
            </div>
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
                alt="Global Business Intelligence"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent"></div>
            </div>

            {/* Floating Stats Cards */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl animate-float">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <span className="text-2xl font-bold text-green-600">90%</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Accuracy Target</p>
                  <p className="text-xs text-gray-500">vs 65% industry standard</p>
                </div>
              </div>
            </div>

            <div className="absolute -top-6 -right-6 bg-white p-4 rounded-xl shadow-xl animate-float" style={{ animationDelay: '0.5s' }}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <span className="text-2xl font-bold text-blue-600">47</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">Jurisdictions</p>
                  <p className="text-xs text-gray-500">EMEA & APAC</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
